import React from 'react';
import { Box, Typography, TypographyProps, Skeleton } from '@mui/material';
import { Theme } from '@mui/material/styles';
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import { RoomType } from '../../../enums/RoomTypes';
import RoomAppBar from '../../Rooms/RoomAppBar';
import RoomContainer from '../components/RoomContainer';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    // 960px
    maxWidth: theme.spacing(120),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 3),
    },
  },
}));
interface Props {
  roomType: RoomType;
  disableContainerScroll?: boolean;
}

const RoomLayoutSkeleton: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();

  const { disableContainerScroll, roomType } = props;

  const isContentLink = roomType === RoomType.ContentLink;

  const renderSectionHeaderSkeleton = (
    variant: TypographyProps['variant'],
    disablePadding = false
  ): JSX.Element => (
    <Box alignItems="center" display="flex" py={disablePadding ? 0 : 1}>
      <Skeleton
        sx={(theme) => ({ height: theme.spacing(5), width: theme.spacing(9) })}
        variant="rectangular"
      />
      <Box flex={1} pl={2}>
        <Typography variant={variant}>
          <Skeleton />
        </Typography>
      </Box>
    </Box>
  );

  const renderContentSkeleton = (): JSX.Element => (
    <Box my={2}>
      <Skeleton
        sx={(theme) => ({ height: theme.spacing(45) })}
        variant="rectangular"
      />
    </Box>
  );

  return (
    <RoomContainer
      appBar={
        <RoomAppBar
          centeredLogos={isContentLink}
          primaryAction={
            !isContentLink ? (
              <Skeleton
                sx={(theme) => ({
                  height: theme.spacing(3.75),
                  width: theme.spacing(16.25),
                })}
                variant="rectangular"
              />
            ) : undefined
          }
        />
      }
      center={
        <>
          {!isContentLink && renderSectionHeaderSkeleton('h5', true)}
          {renderContentSkeleton()}
          {!isContentLink && (
            <>
              {renderSectionHeaderSkeleton('h5')}
              {renderContentSkeleton()}
            </>
          )}
        </>
      }
      classes={{
        container: classNames({
          [classes.container]: isContentLink,
        }),
      }}
      disableContainerScroll={disableContainerScroll}
      right={
        !isContentLink && (
          <>
            <Skeleton
              sx={(theme) => ({ height: theme.spacing(8) })}
              variant="rectangular"
            />
            <Box mt={2}>
              <Skeleton
                sx={(theme) => ({ height: theme.spacing(28) })}
                variant="rectangular"
              />
            </Box>
            <Box mt={2}>
              <Skeleton
                sx={(theme) => ({ height: theme.spacing(12.5) })}
                variant="rectangular"
              />
            </Box>
            <Box mt={2}>
              <Skeleton
                sx={(theme) => ({ height: theme.spacing(4) })}
                variant="rectangular"
              />
            </Box>
          </>
        )
      }
      spacing={5}
    />
  );
};

export default RoomLayoutSkeleton;
